import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const KnxToCrestronStepsStyled = styled(Section)`
  position: relative;

  .title {
    max-width: 500px;
    text-align: center;
    z-index: 1;

    &.mb-1 {
      margin-bottom: 1rem;
    }

    &.mb-3 {
      margin-bottom: 3rem;
    }
  }

  .badge {
    border: 1px solid ${({ theme }) => theme.borderHighlight};
    border-radius: 0.3rem;
    opacity: 0.7;
    padding: 0 0.5rem;
    margin-bottom: 1.25rem;
    max-width: fit-content;
    text-transform: uppercase;
    z-index: 1;
  }

  .subtitle {
    opacity: 0.8;
    margin-bottom: 3rem;
    z-index: 1;

    br {
      @media (max-width: ${breakpoints.screenSM}) {
        display: none;
      }
    }
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    background-color: ${({ theme }) => theme.backgroundPrimary};
    box-shadow: ${({ theme }) => theme.boxShadowPrimary};
    border-radius: 1.25rem;
    width: 85%;
    padding: 2rem;
    margin-bottom: 1.5rem;
    text-align: left;
    z-index: 1;

    @media (max-width: ${breakpoints.screenLG}) {
      width: 100%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      padding: 1.5rem;
    }
  }

  .text-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .number {
    margin-bottom: 1rem;
  }

  .item-title {
    margin-bottom: 0.25rem;
  }

  .item-text {
    max-width: 580px;
  }

  .img-group {
    max-width: 330px;
  }

  .img {
    width: 100%;
  }

  .link {
    position: relative;
    margin-top: 0.5rem;
    z-index: 1;

    &::after {
      content: '';
      position: absolute;
      left: 0px;
      bottom: 1px;
      height: 1px;
      width: 100%;
      background-color: ${({ theme }) => theme.textHighlight};
    }

    p {
      letter-spacing: 0.1em;
      padding-top: 0.2em;
      text-transform: uppercase;
    }
  }

  .link-group {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 0.5rem;
    z-index: 1;

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 1.25rem;
    }

    p {
      letter-spacing: 0.1em;
      padding-top: 0.2em;
      text-transform: uppercase;

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 80%;
        text-align: left;
      }
    }
  }

  .blur-ellipse {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${({ theme }) => theme.backgroundExtraHighlight};
    border-radius: 100%;
    opacity: 0.25;
    filter: blur(60px);
    width: 500px;
    height: 250px;

    &.first {
      top: 30%;
    }

    &.second {
      bottom: 20%;
    }
  }

  .grid-overlay {
    position: absolute;
    top: -10%;
    left: 0;
    width: 100%;

    @media (max-width: ${breakpoints.screenLG}) {
      top: -5%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      top: -2rem;
      height: 100%;
    }
  }
`
